import React from "react";
import Styles from "../WorkspaceDialog.module.css";

type ErrorProps = {
  strings: any;
  message: string;
};

export const UploadDialogError: React.FC<ErrorProps> = ({
  strings,
  message,
}) => {
  return (
    <>
      <div className={Styles.header}>{strings.ERROR}</div>
      <div className={Styles.loading}>{message}</div>
    </>
  );
};
